import { Injectable } from '@angular/core'
import { RestService } from '@service/rest/rest.service'
import { Subscription } from 'rxjs'
import { SentryService } from '@service/sentry.service';

@Injectable({
  providedIn: 'root',
})
export class PreflightSearchService {

  private subscription: Subscription

  constructor(
    private restService: RestService,
    private sentryService: SentryService,
  ) {}

  public doPreflightSearch(data: any): Promise<string[]> {

    if (this.subscription) {
      this.subscription.unsubscribe()
    }

    return new Promise((resolve, reject) => {
      
      this.subscription = this.restService.postWithSubscription(
        'general/searchPreflight/search',
        data
      )
      .subscribe(
        (response: any) => {
          if (response.errors) {
            reject()
          }
          else {
            resolve(response.data)
          }
        },
        err => {
          this.sentryService.silentCaptureException(err)
          reject(err)
        },
      )
    })
  }
}
